
import React from 'react';
import styles from './Hints.module.scss';

export const hintsArray = [
    <>
        <h4>Starting Cash</h4>
        Every player begins with <span className={styles.yellow}>$1,000,000</span>. <br />
        Your mission: protect it across <span className={styles.yellow}>7 rounds</span> of questions.
    </>,
    <>
        <h4>Choosing Categories</h4>
        Each round, one player will pick between <span className={styles.yellow}>2 categories</span>. <br />
        The responsibility rotates — a different player chooses in each round. <br />
        After a category is chosen, a question will appear for everyone.
    </>,
    <>
        <h4>Placing Your Money</h4>
        Place your cash on the answer you think is correct. <br />
        Unsure? You can <span className={styles.yellow}>split your money</span> across multiple answers. <br />
        But remember: you must leave at least <span className={styles.red}>one answer empty</span> every round.
    </>,
    <>
        <h4>Time Limit</h4>
        While answering, make sure to <span className={styles.green}>place all of your cash</span>. <br />
        If the timer runs out, <span className={styles.red}>any unplaced money is lost</span> instantly.
    </>,
    <>
        <h4>Rounds & Answers</h4>
        As the game progresses, the number of answers shrinks: <br />
        <span className={styles.yellow}>Rounds 1–3:</span> 4 possible answers <br />
        <span className={styles.yellow}>Rounds 4–6:</span> 3 possible answers <br />
        <span className={styles.yellow}>Round 7:</span> The Final — only 2 answers remain.
    </>,
    <>
        <h4>Elimination</h4>
        After players lock in their choices, <span className={styles.red}>wrong answers drop</span> and all money placed on them is lost. <br />
        Survive by keeping your money on the <span className={styles.green}>correct answer</span>.
    </>,
    <>
        <h4>Winning the Game</h4>
        At the end of 7 rounds, the winner is: <br />
        • The player with the <span className={styles.yellow}>most money remaining</span>, or <br />
        • If all money is lost, the player who <span className={styles.green}>survived the most rounds</span>. <br />
        Play smart, balance risk, and hold onto your cash!
    </>,
];


// React component to display all hints
const Hints = ({ show, removeBreaks, onClose }) => {
    if (!show) return null;

    return (
        <div className={styles.hintsBackground}>
            <div className={`${styles.hintsContainer} ${removeBreaks ? styles.noBreaks : ''}`}>
                {/* Close button */}
                <button className={styles.closeButton} onClick={onClose}>
                    ×
                </button>

                {hintsArray.map((hint, idx) => (
                    <div key={idx} className={styles.hint}>
                        {hint}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Hints;